module.exports = __webpack_public_path__ + "h5/img/summer-navc22.acc62837.png";